import moment from 'moment';

export const rateLimits = { EUR: [300, 500], USD: [200, 600], GBP: [250, 720] };
export const billingFields = data => ({
  continuous_fulfillment: !!data.continuous_fulfillment,
  settlement_period_start: data.settlement_period_start || null,
  settlement_period_end: data.settlement_period_end || null,
  advance_received_date: data.advance_received_date || null,
  exchange_rate_mode: data.exchange_rate_mode || 'AUTO',
  exchange_rate_date: data.exchange_rate_date || null,
  exchange_rate_source: data.exchange_rate_source || null,
});
const valid = date => !!date && moment(date, 'YYYY-MM-DD', true).isValid();
export function suggestedDelivery(data, issueDate) {
  const start = data.settlement_period_start, end = data.settlement_period_end, due = data.payment_date;
  if (!data.continuous_fulfillment || ![start, end, due, issueDate].every(valid) || start > end) return null;
  // Long periods have additional statutory partial-performance rules, not this ordinary hint.
  if (moment(end).isSameOrAfter(moment(start).add(12, 'months'))) return null;
  if (due > end) return [due, moment(end).add(60, 'days').format('YYYY-MM-DD')].sort()[0];
  if (due < end && issueDate < end) return issueDate;
  return end;
}
export function rateReference(data, receiptType, issueDate) {
  if ((receiptType || '').includes('ADVANCE')) return data.advance_received_date || null;
  if (data.continuous_fulfillment || (receiptType || '').includes('PROFORMA')) return issueDate;
  return data.delivery_date || null;
}

export function settlementPeriodNote(data) {
  const {settlement_period_start: start, settlement_period_end: end} = data;
  if (!data.continuous_fulfillment || !valid(start) || !valid(end) || start > end) return '';
  const language = (data.language || data.locale || 'hu').toLowerCase().split(/[-_]/)[0];
  const formats = {
    hu: ['Elszámolt időszak', 'YYYY.MM.DD', '-', '.'],
    en: ['Billing period', 'DD/MM/YYYY', '–', ''],
    de: ['Abrechnungszeitraum', 'DD.MM.YYYY', '–', ''],
  };
  const format = formats[language];
  if (!format) return '';
  const [label, dateFormat, separator, suffix] = format;
  return `${label}: ${moment(start).format(dateFormat)}${separator}${moment(end).format(dateFormat)}${suffix}`;
}

// Called on period/language edits only, never on loading or saving an invoice.
export function withSettlementPeriodNote(data, patch, state) {
  if (state.edited) return patch;
  const current = data.note || '';
  if (current.trim() && current !== state.generated) return patch;
  if (state.generated && current !== state.generated) { state.edited = true; return patch; }
  const note = settlementPeriodNote({...data, ...patch});
  if (!note && !state.generated) return patch;
  state.generated = note;
  return {...patch, note};
}
